module.exports = __webpack_public_path__ + "img/blank-star-icon.ce354630.png";